import { tagModel } from '@smx-ui-tag/ui/model/tag-model';

import { drawingSetAnnotationModel } from './drawing-set-annotation-model';
import { drawingSetJobModel } from './drawing-set-job-model';
import { drawingSetModel } from './drawing-set-model';
import { drawingSetSheetModel } from './drawing-set-sheet-model';
import { drawingSetVersionModel } from './drawing-set-version-model';
import { StoreDrawingsModelType } from './types';

export const storeDrawingsModel: StoreDrawingsModelType = {
    drawingSet: drawingSetModel,
    drawingSetVersion: drawingSetVersionModel,
    tag: tagModel,
    drawingSetSheet: drawingSetSheetModel,
    drawingSetJob: drawingSetJobModel,
    drawingSetAnnotation: drawingSetAnnotationModel,
};
